import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import AppChrome from './components/AppChrome';

/**
 * Routes are code-split so a visitor only downloads the page they landed on.
 *
 * This matters most for the two public routes: someone scanning a printed code
 * arrives at /s/:shortId or /c/:shortId on mobile data, and has no use for
 * Chart.js or the dashboard. Loading them eagerly put all of it in one ~538 kB
 * bundle that every visitor paid for.
 */
const Dashboard = lazy(() => import('./pages/Dashboard'));
const QRGenerator = lazy(() => import('./pages/QRGenerator'));
const QRList = lazy(() => import('./pages/QRList'));
const PrintSheet = lazy(() => import('./pages/PrintSheet'));
const QRDetails = lazy(() => import('./pages/QRDetails'));
const ScanRedirect = lazy(() => import('./pages/ScanRedirect'));
const ContactCardPage = lazy(() => import('./pages/ContactCard'));

function App() {
  return (
    <Router>
      <div className="App">
        <AppChrome />
        <Suspense fallback={<div className="loading">Loading…</div>}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/generate" element={<QRGenerator />} />
            <Route path="/qr-codes" element={<QRList />} />
            <Route path="/print" element={<PrintSheet />} />
            <Route path="/qr/:id" element={<QRDetails />} />
            <Route path="/s/:shortId" element={<ScanRedirect />} />
            <Route path="/c/:shortId" element={<ContactCardPage />} />
          </Routes>
        </Suspense>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </Router>
  );
}

export default App;
